import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAwardMedalFilled = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M7.99967 1.33325C10.577 1.33325 12.6663 3.42259 12.6663 5.99992C12.6663 7.4766 11.9805 8.79309 10.9099 9.6482C10.112 10.2856 9.10032 10.6666 7.99967 10.6666C6.89903 10.6666 5.88738 10.2856 5.08944 9.6482C4.01888 8.79309 3.33301 7.4766 3.33301 5.99992C3.33301 3.42259 5.42235 1.33325 7.99967 1.33325Z",
		fill: "#111827"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M10.9099 9.6482L11.9997 14.6666C9.14206 12.8905 6.85729 12.8905 3.99967 14.6666L5.08944 9.6482",
		stroke: "#111827",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgAwardMedalFilled);
export default ForwardRef;
